<template>
    <div id="cart-step" class="sf-cart-modal" sf-component="cart-modal" sf-version="1.0">
        <route v-if="active == true" :defaultValue="preselection" :f="f" :f1="f1" :f2="f2" :gas="gas"> </route>
    </div> 
</template>

<script >
    import route from "./components/Cart-step/Route.vue";

export default {
    name: "App",
    components: {
        route,
    },

    props: {
        f: Number,
        f1: Number,
        f2: Number,
        gas: Number,
    },

    data: function() {
        return {
            ver: "2806a",
            preselection: "null",
            active: false,
        };
    },

    created: function() {
        console.log("Release: " + this.ver);

        let _self = this;

        function init(counter) {
            if (counter < 8) {
                setTimeout(function() {
                    _self.stepcart();
                    counter++;
                    init(counter);
                }, 1000);
            }
            console.log("[mm] scanning buttons: " + counter + " times");
        }

        init(0);
    },

    methods: {
        getPreselection: function( event ) {
            let utility = "";
            let presel = window.jQuery(event.target).closest('[sf-cart-id="link"]');
            utility = presel.attr("sf-cart-utility");
            if (!utility) {
                presel = presel.find("[sf-cart-utility]");
                utility = presel.attr("sf-cart-utility");
            }
            this.preselection = utility;
        },

        clickPreselection: function() {
            this.preselectionId = "commodity_" + this.preselection.toLowerCase().replace(/\s+/g, "");
            document.getElementById(this.preselectionId).click();
        },

        stepcart: function() {
            let _self = this;

            let carts = document.querySelectorAll('[sf-cart-id="link"]');
            console.log("cart-step stepcart carts", carts);

            for (let i = 0; i < carts.length; i++) {
                let buttons = carts[i].querySelectorAll('[sf-cart-modal-switch="slide-up"]');
                console.log("cart-step stepcart button", buttons);

                for (let i = 0; i < buttons.length; i++) {
                    if (!buttons[i].hasAttribute("active")) {
                        console.log("App stepcart buttons " + i + " attivato!");

                        buttons[i].setAttribute("active", "yes");

                        buttons[i].addEventListener("click", function(event) {
                            _self.active = true;
                            event.preventDefault();
                            event.stopPropagation();

                            setTimeout(function () {
                                _self.getPreselection( event );
                                _self.clickPreselection( );
                            
                                document.getElementById("cart-step").classList.add("open");
                                return false;
                            }, 250);
                        });
                    }
                }
            }
        },
    },
}; 
</script>


<style >
</style>